import React from "react";
import PageHero from "@/components/PageHero";
import IndustriesSection from "@/components/sections/IndustriesSection";
import IndiaEurope from "@/components/sections/IndiaEurope";
import CTA from "@/components/sections/CTA";
import { useT } from "@/lib/i18n";

export default function Industries() {
  const { t } = useT();
  return (
    <div data-testid="page-industries">
      <PageHero
        eyebrow={t("nav.industries")}
        title={
          <>
            {t("page.ind.title.a")}{" "}
            <span className="text-[color:var(--zp-text-3)]">{t("page.ind.title.b")}</span>
          </>
        }
        subtitle={t("page.ind.sub")}
      />
      <IndustriesSection />
      <IndiaEurope />
      <CTA />
    </div>
  );
}
